import { useEffect, useState } from "react";
import Vocab from "../../models/Vocab";
import { clearCache, fetchVocabsCached } from "../../cachedStaticData";
import { Loading } from "../Misc/Loading";
import { useVocabSigns } from "../../hooks/useALSE";
import SignList from "../SignSearchView/SignList";
import Sign from "../../models/Sign";
import SignModal from "../SignModal/SignModal";
import './Vocabs.css';
import HasPermission from "../../claims/SessionClaims";
import { teacher_permission } from "../../config";
import { addVocab } from "../../services/api";
import CookiesModal from "../CookiesModal/CookiesModal";

export default function Vocabs() {
    // Permissions
    const has_teacher_permission = HasPermission(teacher_permission);
    
    const [vocabs, setVocabs] = useState<Vocab[]>([]);
    const [selectedVocab, setSelectedVocab] = useState<Vocab | null>(null);
    const [vocabsRefresh, setVocabsRefresh] = useState<number>(0);
    const { data: signs, loading, error } = useVocabSigns(selectedVocab?.vocab_id ?? -1, [selectedVocab]);
    const [vocabInputValue, setVocabInputValue] = useState<string>('');
    const [maxLevel, setMaxLevel] = useState<number>(1);


    // Load vocabs
    useEffect(() => {        
        const fetchData = async() => {
            setVocabs(await fetchVocabsCached());
        }
        fetchData();
    }, [vocabsRefresh]);
    
    // Sign modal
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<Sign | null>(null);

    const handleOpenModal = (data: Sign) => {
        setModalData(data);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setModalData(null);
    };


    const handleFormSubmit = async () => {
        const response = await addVocab(vocabInputValue, maxLevel);
        if (response.ok) {
            clearCache();
            setVocabsRefresh(vocabsRefresh+1);
        }
    }
    
    if (selectedVocab !== null) {
        return <div className="component-container">
            <div>
                <button className="btn back-button" onClick={() => setSelectedVocab(null) }>⬅️</button>
                <h2>{selectedVocab.name}</h2>
            </div>
            <SignList 
                signs={signs} 
                inputValue={selectedVocab.toString()} 
                handleOpenModal={handleOpenModal} 
                loading={loading} 
                error={error ? Error(error) : undefined}
                notFoundMsg='Aún no tenemos signos dentro de esta categoría 🫤'
            />
            <SignModal isOpen={isModalOpen} onClose={handleCloseModal} sign={modalData} />
            <CookiesModal/>
        </div>
    }

    if (vocabs.length === 0)
        return <Loading />

    return <div className="component-container">
        {/* <h2>Categorias</h2> */}
        <ul className="button-list">
            {vocabs.map((vocab, idx) => (
                <li key={idx}>
                    <button onClick={() => setSelectedVocab(vocab)}>
                        <div className="name capitalize">{vocab['name']}</div>
                    </button>
                </li>
            ))}
        </ul>
        {
            has_teacher_permission && 
            <form className="d-flex" onSubmit={handleFormSubmit}>
                <input id="create-vocab-input" 
                    type="text"
                    aria-label="Input categoría a crear"
                    value={vocabInputValue}
                    onChange={(e) => setVocabInputValue(e.target.value)}
                    placeholder="Nueva categoría"/>
                <select onChange={(e) => setMaxLevel(Number(e.currentTarget.value))} value={maxLevel}>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                </select>
                <button type="submit">➕</button>
            </form>
        }
        <CookiesModal/>
    </div>
}